<div class="wrapper">
  <div *ngIf="!showAdvanced">
      <div class="card mw-20 p-1 float-right advTxt" (click)="showAdvancedSearch();">
        <div class="card-body card-search-body">
          Advanced Search<img class="searchImage" alt="" />
        </div>
      </div>
  </div>

  <div *ngIf="showAdvanced">
    <div class="container-md mw-100 p-0">
      <div class="card card2 pt-4 pb-4">
        <div class="card-title">Advanced Search
          <span class="hide-adv" (click)="hideAdvancedSearch();">Hide</span>
        </div>

        <div class="card-body">
          <form [formGroup]="advSearch" (ngSubmit)="submitForm();">
            <div class="row">
              <div class="col-sm">
                <label for="route">Region / Route</label>
              </div>
              <div class="col-sm">
                <label for="route">Depot</label>
              </div>
              <div class="col-sm">
                <label for="route">Created by</label>
              </div>
              <div class="col-sm">
                <label for="route">Status</label>
              </div>
            </div>

            <div class="row">
              <div class="col-sm">

                <ng-multiselect-dropdown [placeholder]="' '" [settings]="dropdownSettings" [data]="routeList"
                  formControlName="route" #routelistElement (onSelect)="onRouteItemSelect($event)"
                  (onSelectAll)="onRouteSelectAll($event)" (onDeSelect)="onRouteItemDeselect($event)">
                </ng-multiselect-dropdown>
              </div>
              <div class="col-sm">
                <ng-multiselect-dropdown [placeholder]="' '" [settings]="dropdownSettings" [data]="depotList"
                  formControlName="depot" #depotlistElement (onSelect)="onItemSelect($event)"
                  (onSelectAll)="onSelectAll($event)">
                </ng-multiselect-dropdown>
              </div>
              <div class="col-sm">
                <!-- <input type="text" class="form-control input-sm txt-input" formControlName="submittedBy"> -->

                <input matInput type="search" class="form-control" [matAutocomplete]="auto"
                  formControlName="submittedBy" placeholder="search using tester name" (input)="clearUserField();" />

                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getuserData($event)" [displayWith]="displayProperty">
                  <mat-option *ngFor="let state of filteredUsers | async" [value]="state">
                    <span>{{state.displayName }} - {{state.jobTitle}}</span>
                    <!-- <small>Population: {{state.population}}</small> -->
                  </mat-option>
                </mat-autocomplete>
              </div>

              <div class="col-sm">
                <ng-multiselect-dropdown [placeholder]="' '" [settings]="dropdownSettings" [data]="statusList"
                  formControlName="status" (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)">
                </ng-multiselect-dropdown>
              </div>
            </div>

            <div class="row pt-2">
              <div class="col-sm">
                <label for="route">Created on</label>
              </div>
              <div class="col-sm">
                <label for="route">Test Plan executed</label>
              </div>
              <div class="col-sm">
                <label for="route">Equipment</label>
              </div>
              <div class="col-sm">
              </div>
            </div>

            <div class="row">
              <div class="col-sm">
                <div class="row">
                  <div class="col-sm-2 pl-3 pr-1">
                    <img class="calendar-img">
                  </div>
                  <div class="col-sm-5 pl-0">
                    <input matInput [max]="maxDate" type="search" class="form-control" [matDatepicker]="picker" placeholder="DD/MM/YYYY" formControlName="submittedfrom"
                    (click)="picker.open()" />
                    <mat-datepicker #picker></mat-datepicker>
                  </div>
                  <div class="col-sm-5 pl-0">
                    <input matInput [max]="maxDate" type="search" class="form-control" [matDatepicker]="picker2" placeholder="DD/MM/YYYY" formControlName="submittedTo"
                    (click)="picker2.open()" />
                    <mat-datepicker #picker2></mat-datepicker>
                  </div>
                </div>
              </div>
              <div class="col-sm">
                <input type="text" class="form-control input-sm txt-input" formControlName="plansExecuted" placeholder="search using testplan id">
              </div>

              <div class="col-sm">
                <input type="text" class="form-control input-sm txt-input" formControlName="assetId" placeholder="search using asset id">
              </div>
              <div class="col-sm pt-1">
                <input type="checkbox" class="form-control chk-box" aria-label="handoverOnly"
                  formControlName="handoverOnly">
                <label for="handoverOnly">Only show slips with handover</label>
              </div>
            </div>

            <div class="row pt-4">
              <div class="col">
                <button type="button" (click)="reset();" class="btn btn-info btn-sm">Reset</button>
              </div>
              <div class="col">
                <button type="button" (click)="submitForm();" class="btn btn-info btn-sm btn-right">Apply
                  Filter</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
